export default __webpack_public_path__ + "static/lufthansa-260d92b9fbdcfb91be5f562e42fafab9.png";